export default __webpack_public_path__ + "static/media/como-cadastrar-pagina3.565b766f.svg";